/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { request, ResponseList } from '../request'
import type { RequestResponse } from '../request'
import type {
  AssetGroup,
  GetAssetGroupListParams,
  AddAssetGroupParams,
  AddAssetGroupChildrenParams,
  DeleteAssetGroupChildrenParams,
  AssetGroupInfo,
  AddToProjectParams,
  AddAssetGroupChildTextParams,
  ResourceSummaryProperty,
  ReplaceAssetGroupChildrenParams,
} from './type'
import type { ProjectAssetsModel } from '../aside/type'
import type { ProjectModel, ProjectSegmentModel } from '../project/type'

// 资源组列表
export const getAssetGroupList = (params: GetAssetGroupListParams) =>
  request.get<RequestResponse<ResponseList<AssetGroup[]>>>(
    `veditor/asset-group/list`,
    {
      params,
    },
  )

// 创建资源组
export const addAssetGroup = (data: AddAssetGroupParams) =>
  request.post<
    RequestResponse<
      Pick<
        AssetGroupInfo,
        'asset_type' | 'assets' | 'id' | 'name' | 'project_id'
      >
    >
  >('veditor/asset-group/create', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

// 删除组
export const deleteAssetGroup = (data: { id: AssetGroup['id'] }) =>
  request.post<RequestResponse>('veditor/asset-group/del', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

// 删除组
export const updateAssetGroupName = (data: {
  id: AssetGroup['id']
  name: string
}) =>
  request.post<RequestResponse>('veditor/asset-group/rename', data, {
    headers: {
      'Content-Type': 'application/json',
    },
  })

// 复制组
export const copyAssetGroup = (data: {
  project_id: ProjectModel['id']
  group_asset_ids: AssetGroup['id'][]
  delete_source?: boolean // 是否删除源资源组
  keep_created_time?: boolean // 保持原有创建时间不变
}) =>
  request.post<
    RequestResponse<
      Pick<
        AssetGroupInfo,
        'asset_type' | 'assets' | 'id' | 'name' | 'project_id'
      >[]
    >
  >('veditor/asset-group/copy', data, {
    headers: { 'Content-Type': 'application/json' },
  })

// 组详情
export const getAssetGroupInfo = (params: { id: AssetGroup['id'] }) =>
  request.get<RequestResponse<AssetGroupInfo>>('veditor/asset-group/info', {
    params,
  })

// 新增子资源
export const addAssetGroupChildren = (
  data: AddAssetGroupChildrenParams | AddAssetGroupChildTextParams,
) => {
  const _data = data as any
  const res_ids = _data.res_ids ? { res_ids: _data.res_ids } : {}

  return request.post<
    RequestResponse<{ segments: ProjectSegmentModel[] | null }>
  >(
    'veditor/asset-group/add-assets',
    {
      ...data,
      ...res_ids,
    },
    {
      headers: { 'Content-Type': 'application/json' },
    },
  )
}

// 删除子资源
export const deleteAssetGroupChildren = (
  data: DeleteAssetGroupChildrenParams,
) => {
  return request.post<RequestResponse>(
    'veditor/asset-group/del-assets',
    {
      ...data,
      ids: data.ids,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
}

// 设置默认子资源
export const setAssetGroupChildrenDefault = (data: {
  id: ProjectAssetsModel['id']
}) => {
  return request.post<RequestResponse>(
    'veditor/asset-group/set-default-asset',
    {
      ...data,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
}

// 设置默认子资源
export const setAssetGroupText = (data: AddAssetGroupChildTextParams) => {
  return request.post<RequestResponse>(
    'veditor/asset-group/update-asset',
    {
      ...data,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
}

// 资源库弹窗-批量添加到资源组
export const batchAddToProject = (data: AddToProjectParams) => {
  return request.post<RequestResponse<{ assets: ProjectAssetsModel[] | null }>>(
    'veditor/asset/add-to-project',
    {
      ...data,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
    },
  )
}

// 项目组资源汇总
export const getResourceSummary = (project_id: ProjectModel['id']) =>
  request.get<RequestResponse<ResourceSummaryProperty[] | null>>(
    'veditor/asset-group/resource-summary',
    {
      params: {
        project_id,
      },
    },
  )

// 替换子资源
export const replaceAssetGroupChildren = (
  data: ReplaceAssetGroupChildrenParams,
) => {
  return request.post<
    RequestResponse<{ segments: ProjectSegmentModel[] | null }>
  >('veditor/asset-group/replace-assets', data, {
    headers: { 'Content-Type': 'application/json' },
  })
}
